__turbopack_context__.v({
  "close": "virtual-agent-skeleton-module-scss-module__k1eNsq__close",
  "container": "virtual-agent-skeleton-module-scss-module__k1eNsq__container",
  "header": "virtual-agent-skeleton-module-scss-module__k1eNsq__header",
  "skeleton": "virtual-agent-skeleton-module-scss-module__k1eNsq__skeleton",
  "title": "virtual-agent-skeleton-module-scss-module__k1eNsq__title",
});
